import {
  alpha,
  Box,
  Button,
  ButtonBase,
  Grid,
  styled,
  Typography,
} from '@mui/material';

const shellHeight = {
  minHeight: '720px',
  height: '100vh',
};

export const ContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  ...shellHeight,
  justifyContent: 'center',
  background: theme.palette.primary.main,
}));

export const LogoGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.primary.main,
}));

export const LogoImg = styled(Box)(({ theme }) => ({
  zIndex: 5,
  img: {
    [theme.breakpoints.down('lg')]: {
      width: 400,
    },
    [theme.breakpoints.up('lg')]: {
      width: 547,
    },
  },
}));

export const ContentGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  ...shellHeight,
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: '30px',
  borderBottomLeftRadius: '30px',
  overflowY: 'auto',
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  width: '100%',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '48px 60px',
  [theme.breakpoints.down('xl')]: {
    padding: '32px 40px',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 'bold',
  margin: '12px 0',
  textAlign: 'center',
  color: theme.palette.primary.main,
  [theme.breakpoints.down('xl')]: {
    fontSize: '22px',
  },
}));

export const SectionDialog = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  textAlign: 'center',
  marginBottom: '12px',
  [theme.breakpoints.down('xl')]: {
    fontSize: '14px',
  },
}));

export const QRCodeContainer = styled(Box)(() => ({
  background: 'grey',
  padding: '12px',
  margin: '20px 0',
  borderRadius: '8px',
  '& > div': {
    background: 'white',
    padding: '12px',
    height: '160px',
    width: '160px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
  },
  '& > div > svg': {
    height: '100%',
    width: '100%',
  },
}));

export const HowToScanner = styled(Box)(() => ({
  backgroundColor: '#F5F5F4',
  width: '100%',
  padding: '20px',
  borderRadius: '4px',
  borderColor: '#e9e9e9',
}));

export const TitleItem = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '& span': {
    color: theme.palette.primary.main,
  },
}));

export const ListItem = styled(Typography)(({ theme }) => ({
  margin: '12px 0 12px 32px',
  fontSize: '16px',
  [theme.breakpoints.down('xl')]: {
    fontSize: '14px',
  },
}));

export const SecretBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '14px 12px',
  backgroundColor: alpha(theme.palette.primary.light, 0.1),
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& > span': {
    fontSize: '16px',
    wordBreak: 'break-all',
  },
}));

export const Span = styled('span')(({ theme }) => ({
  color: theme.palette.common.grey,
  margin: '12px 0 6px 0',
  fontSize: '14px',
  [theme.breakpoints.down('xl')]: {
    fontSize: '12px',
  },
}));

export const Counter = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '8px',
  fontWeight: 'bold',
  '& span': {
    fontWeight: 'normal',
    fontSize: '24px',
    color: theme.palette.primary.main,
  },
}));

export const NewCodeButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '16px',
  textDecoration: 'underline',
  cursor: 'pointer',
  marginTop: '16px',
  '&.Mui-disabled': {
    color: alpha(theme.palette.primary.main, 0.5),
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '14px',
  },
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  margin: '32px 0 8px',
  gap: '16px',
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  fontWeight: 'bold',
  minWidth: '140px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const OutlinedStyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  border: '2px solid',
  borderColor: theme.palette.secondary.main,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  fontWeight: 'bold',
  minWidth: '140px',
}));
